import { useToast, Text } from '@chakra-ui/react'
import { ErrorBoundary } from 'react-error-boundary'

const WidgetWrapper = ({ children }: { children: React.ReactNode }) => {
  const toast = useToast()

  return (
    <ErrorBoundary
      fallback={<Text color="brand.secondary">Widget failed to load</Text>}
      onError={(error: Error) => {
        toast({
          title: 'Error loading widget',
          description: error.message,
          status: 'error',
          duration: 5000,
          isClosable: true,
        })
      }}
    >
      {children}
    </ErrorBoundary>
  )
}

export default WidgetWrapper
